<template>
  <div class="footer" ref="footer" id="home-footer">
    <div class="footer-top">
      <div class="content">
        <div class="left">
          <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion" class="logo" />
          <p class="p2">{{activityDetail.name | dealLanguage(activityDetail.enName)}}</p>
          <!-- <p class="p2">{{'中国·北京' | dealLanguage('BEIJING·CHINA')}}</p>
          <p class="p2">{{'2025年9月12日至9月13日' | dealLanguage('SEP 12-13, 2025')}}</p> -->
        </div>
        <div class="center">
          <div class="link">
            <div class="link-title">CSGCT</div>
            <div class="link-list">
              <div v-for="item,index in navPosition1" :key="index"><a @click="handleChangeRoute('contentPage' + item.id)">{{item.pageName | dealLanguage(item.enPageTitle)}}</a></div>
              <div><a @click="handleChangeRoute('guests')">{{'发言嘉宾' | dealLanguage('Guests')}}</a></div>
              <div><a @click="handleChangeRoute('newsList')">{{'新闻动态' | dealLanguage('NEWS')}}</a></div>
            </div>
          </div>
          <div class="link" v-if="btnList.length">
            <div class="link-title">{{'快捷入口' | dealLanguage('QUICK ACCESS')}}</div>
            <div class="link-list">
              <div v-for="item,index in btnList" :key="index"><a @click="clickBanner(item, 'footer')">{{item.description}}</a></div>
            </div>
          </div>

          <div class="link">
            <div class="link-title">{{'联系我们' | dealLanguage('CONTACT')}}</div>
            <div class="str">
              <p>{{'大会咨询请联系' | dealLanguage('For meeting inquiries, please contact: ')}}</p>
              <p>{{'贺亦轩' | dealLanguage('He YiXuan')}}</p>
              <p>{{'邮箱：join@csgct.com.cn' | dealLanguage('Email: join@csgct.com.cn')}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="inter-link" v-if="links.length">
        <p class="title">{{'友情链接' | dealLanguage('Friendly Links')}}</p>
        <div class="links">
          <a v-for="item,index in links" :key="index" :href="item.link_url" target="_blank">
            <img :src="item.img_path | logo_show" :alt="item.title">
          </a>
        </div>
      </div> -->
    </div>
    <!-- <div class="footer-bottom">
      <a href="http://beian.miit.gov.cn" target="_blank">© 动脉橙 渝ICP备18013108号</a>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502165">
        <img :src="img_req_url + '/upload/vcbeat/public/images/pb-icon.png?v=' + $store.state.imgVersion" />
        渝公网安备 50011202502165号
      </a>
      <a href="javascript:void(0)" @click="certificate_model = true">互联网药品信息服务资格证书：（渝）-非经营性-2023-0083</a>
    </div> -->
    <!-- <Modal class="certificate-model" v-model="certificate_model" width="960" :footer-hide="true">
      <img :src="static_img_url + 'pic/certificate.jpg'" class="certificate-img" />
    </Modal> -->
  </div>
</template>

<script>
// import { getFriendlyLinks } from '@/service/php'
import { mapState } from 'vuex'
export default {
  inject: ['clickBanner', 'globalInsertRecords'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  data() {
    return {
      certificate_model: false,
      links: [],
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      img_req_url: (state) => state.img_req_url,
      language: (state) => state.language,
      contentNav: (state) => state.contentNav,
      activityDetail: (state) => state.activityDetail,
    }),
    /**
     * 关于CSGCT
     */
    navPosition1() {
      let arr = this.contentNav.filter((item) => [263].includes(item.id))
      return arr
    },
  },
  methods: {
    // async getFriendlyLinks() {
    //   let res = await getFriendlyLinks({}, (error) => {
    //     this.$Message.error(this.language == 'zh' ? '请求错误！' : 'Request error!')
    //   })
    //   if (res.status == 'success') {
    //     this.$set(this.$data, 'links', res.res)
    //   } else {
    //     console.log(res)
    //   }
    // },
    handleChangeRoute(name) {
      // 判断name是否包含contentPage
      if (name.indexOf('contentPage') > -1) {
        let content_id = name.split('contentPage')[1] - 0
        let index = this.contentNav.findIndex((item) => item.id == content_id)
        if (index > -1) {
          this.globalInsertRecords({
            contentId: content_id,
            contentType: 81,
            viewType: 1,
            keyword: this.contentNav[index].pageName,
          })
        }
        this.$router.push({ name: 'exhibitionDesc', params: { id: content_id } })
        return
      }
      let kw = ''
      switch (name) {
        case 'guests':
          kw = '发言嘉宾'
          break
        case 'newsList':
          kw = '新闻动态'
          break
      }
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      this.$router.push({ name })
    },
  },
  created() {
    // this.getFriendlyLinks()
  },
}
</script>

<style lang="stylus" scoped>
.footer
  width 100%
  min-width 1200px
  z-index 100
  .footer-top
    width 1200px
    margin 0 auto
    padding 50px 0 30px
    .content
      display flex
      justify-content space-between
      .left
        .logo
          display block
          width auto
          height 60px
          font-size 0
          &+.p2
            margin-top 24px
        .p2
          font-size 14px
          font-weight 400
          color #333333
          line-height 20px
          &+.p2
            margin-top 20px
      .center
        display flex
        padding-top: 35px
        .link
          &+.link
            margin-left: 40px
          .link-title
            font-size 16px
            color #C8161D
            line-height 22px
            font-weight bold
          .str
            margin 27px 0 0 0
            font-size 14px
            color #333333
            line-height 20px
            p+p
              margin-top 20px
          .link-list
            padding-top 7px
            > div
              margin-top 20px
            a
              font-size 14px
              color #333333
              line-height 20px
              transition all 0.3s
              cursor pointer
              &:hover
                color #C8161D
    .inter-link
      margin-top 30px
      line-height 1
      .title
        color #333
        font-size 14px
        margin-bottom 0
        font-weight 800
        line-height 1
      .links
        margin-top 15px
        display grid
        grid-template-columns repeat(13, 80px)
        grid-row-gap 10px
        grid-column-gap 10px
        a
          font-size 14px
          margin-right 0
          margin-bottom 0
          color #999
          line-height 1
          width auto
          height 40px
          display flex
          justify-content center
          align-items center
          border 1px solid #e9e9e9
          padding 4px
          border-radius 2px
          cursor pointer
          overflow hidden
          transition all 0.3s
          img
            max-width 100%
            max-height 100%
          &:hover
            border-color #C8161D
  .footer-bottom
    width 100%
    height 48px
    background #000
    text-align center
    display flex
    align-items center
    justify-content center
    a
      font-size 12px
      color #fff
      display flex
      align-items center
      img
        margin-right 5px
        width 16px
      &+a
        margin-left 20px
      &:hover
        color #C8161D
.certificate-model
  >>> .ivu-modal-content
    border-radius 0
    .ivu-modal-close
      .ivu-icon-ios-close
        color #fff
    .ivu-modal-body
      padding 0
      font-size 0
.certificate-img
  width 100%
</style>
